/** Sidebar tab labels — single source for nav, page headings, and browser titles where applicable */
export const MAIN_TAB_PAGE_LABEL = {
  documentsList: 'Documents',
  scribe: 'Scribe',
  outcomeTasks: 'Outcome Tasks',
  referrals: 'Referrals',
  patientSearch: 'Patient Search',
  insights: 'Insights',
  clinics: 'Clinics',
  admin: 'Admin',
  user: 'User',
  configuration: 'Configuration',
};

export const BROWSER_PAGE_LABEL = {
  documentDetail: 'Document',
  consultationDetail: 'Consultation',
};

export function medPromptBrowserTitle(pageLabel) {
  return `MedPrompt - ${pageLabel}`;
}
